'use client';

import type { Parameter } from '@eliadmin/core/src/components/dlz/product-detail/details/product-detail-content';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/**
 * Figma „Parameters“ (60137:5662): title and a bordered table (radius 18) of label / value rows,
 * every other row on bg/surface starting with the first one. Phones split a row into two equal
 * columns (Figma 60459:102832).
 */
export function ProductParameters({ parameters }: { parameters: Parameter[] }) {
  const { t } = useTranslations();

  return (
    <div className="flex min-w-0 flex-col gap-4">
      <h2 className="dlz-h3 text-[#0F1012]">{t('text9')}</h2>
      <dl className="overflow-hidden rounded-[18px] border border-[#E2E4E7]">
        {parameters.map(parameter => (
          <div
            key={parameter.id}
            className="grid grid-cols-2 gap-3 px-4 py-3 odd:bg-[#F5F6F7] md:grid-cols-[180px_minmax(0,1fr)] md:gap-4 md:px-6"
          >
            <dt className="dlz-body-s text-[#6B7079] [overflow-wrap:anywhere]">{parameter.name}</dt>
            <dd className="dlz-body-s-medium text-[#0F1012] [overflow-wrap:anywhere]">
              {parameter.value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
